import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';
import { RdLocalizedNumberPipe } from '../../../pipes/rd-localized-number.pipe';

/**
 * IncomeExitBalanceOfIrr Widget
 */
@Component({
  selector: 'income-exit-balance-of-irr-widget',
  templateUrl: './income-exit-balance-of-irr-widget.component.html',
  styleUrls: ['./income-exit-balance-of-irr-widget.component.scss', '../../common/css/general.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncomeExitBalanceOfIrrWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Is chart ready to be shown?
   */
  public chartReady = false;

  /**
  * Constructor
  * @param rdLocalizedNumberPipe RdLocalizedNumberPipe
  */
  constructor(injector: Injector, private rdLocalizedNumberPipe: RdLocalizedNumberPipe) {
    super(injector, 'incomeExitBalanceOfIrr', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('incomeExitBalanceOfIrr');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('incomeExitBalanceOfIrr', this.getReport());
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    data.entries = [];

    this.pushIfNotEmpty(data.entries, { "label": 'incomeExitBalanceOfIrr.netOperatingIncome', "value": parseFloat(data.netOperatingIncome || 0) });
    this.pushIfNotEmpty(data.entries, { "label": 'incomeExitBalanceOfIrr.terminalValue', "value": parseFloat(data.terminalValue || 0) });

    //translate in RD locale
    this.reportDesignerTranslator.ready('incomeExitBalanceOfIrr').then((_result) => {
      for (const entry of data.entries) {
        entry.label = this.reportDesignerTranslator.getString(entry.label);
      }
      this.chartReady = true;
    });

    //calculate percentages to be displayed in chart
    const total = data.entries.map(e => e.value).reduce((prev, curr) => prev + curr, 0);
    for (const entry of data.entries) {
      const value = Math.round(100 * (entry.value / total) * 100) / 100;
      const formattedValue = this.rdLocalizedNumberPipe.transform(value, 2, false, '', '', 0);
      entry.percentageFormatted = `${formattedValue}%`;
    }

    this.sortChartData(data.entries);
    return data;
  }

  /**
   * Push object to array if not empty
  * @param array {Array<any>} Array
  * @param obj {any} Object
   */
  private pushIfNotEmpty(array: Array<any>, obj: any) {
    if (Math.abs(obj.value) > 1E-6) {
      array.push(obj);
    }
  }

  /**
   * Sorts chart data
  * @param data {any} Data
   */
  private sortChartData(data) {
    data.sort((a, b) => {
      const valueA = a.value;
      const valueB = b.value;
      if (valueA < valueB) {
        return -1;
      }
      else if (valueA > valueB) {
        return 1;
      }
      return 0;
    });

    data.reverse();
  }

  /**
   * Returns chart label content
  * @param e {any} Event object
   */
  chartLabelContent(e: any): string {
    return e.dataItem.percentageFormatted;
  }

}
